<template>
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'view_charity']))">
    <Toast/>
    <div class="card card-theme">
      <Steps :model="items" :readonly="true" style="margin-bottom: 1rem"/>
    </div>
    <keep-alive>
      <router-view :formData="formObject" @prevPage="prevPage($event)" @nextPage="nextPage($event)"
                   @complete="complete"/>
    </keep-alive>
  </div>
</template>

<script>
  import CharityService from '../../services/CharityService';
  import UserService from '../../services/UserService';

  export default {
    name: 'NewCharity',
    props: {
      mode: {
        type: String,
        required: false
      },
      charity_id: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        items: [{
            label: 'General Info',
            to: '/charity/general'
          },
          {
            label: 'Staff',
            to: '/charity/staff'
          }
        ],
        formObject: {},
        user_accesses: this.$store.state.accesses,
        userService: null,
        charityService: null,
      }
    },
    methods: {
      nextPage(event) {
        (event.pageIndex < this.items.length - 1) ? this.$router.push(this.items[event.pageIndex + 1].to).catch() : this.$router.push('/charities').catch()
      },
      prevPage(event) {
        this.$router.push(this.items[event.pageIndex - 1].to).catch();
      },
      complete(event) {
        for (let field in event.formData) {
          this.formObject[field] = event.formData[field];
        }

        let charity_info = localStorage.getItem("charity_info") ? JSON.parse(localStorage.getItem("charity_info")) : null;
        this.formObject.id = charity_info ? charity_info.id : null;
        this.charityService.setCharity(this.formObject).then((result) => {
          if (result.status === 200) {
            localStorage.setItem("charity_info", JSON.stringify(result.data.charity));
            (event.pageIndex < this.items.length - 1) ? this.$router.push(this.items[event.pageIndex + 1].to).catch() : this.$router.push('/charities').catch()
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to submit',
              detail: result.data.error
            });
          }
        });
      },
    },
    created() {
      this.charityService = new CharityService();
      this.userService = new UserService();
      if (!this.user_accesses) {
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      if (this.$route.path === '/charity') {
        localStorage.removeItem("charity_info");
        this.$router.push('/charity/general').catch();
      }
      else if (this.mode === 'edit' && this.charity_id) {
        this.charityService.getCharity(this.charity_id).then(response => {
          console.log(response);
          localStorage.setItem("charity_info", JSON.stringify(response.data.charity));
          this.$router.push('/charity/general').catch();
          // setTimeout(function(){ this.$router.push('/client/general').catch(); }, 100);
        });
      }
    }
  }

</script>

<style scoped>

</style>